import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SidebarComponent from '../common/sidebar-component';
import OrganisationResultsContext from './context';
import SidebarComponentHeader from '../common/sidebar/sidebar-component-header';
import useGetAreasOfExpertise from '../../../services/areas-of-expertise/areas-of-expertise-by-organisation-service';
import Expertise from '../common/sidebar/expertise';

const AreasOfExpertiseContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 20px;
`;

export default function TopAreasOfExpertise({ organisation }) {
  const { dispatch } = React.useContext(OrganisationResultsContext);
  const [{ data }, executeQuery] = useGetAreasOfExpertise(organisation, 5);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'areasOfExpertise.length')) {
      dispatch({ type: 'setAreasOfExpertise', payload: data.areasOfExpertise });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'areasOfExpertise.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarComponentHeader
        title="expertise within"
        query={organisation}
      />
      <AreasOfExpertiseContainer>
        {data.areasOfExpertise.map(expertise => <Expertise key={`expertise-${expertise.id}`} expertise={expertise} />)}
      </AreasOfExpertiseContainer>
    </SidebarComponent>
  );
}

TopAreasOfExpertise.propTypes = {
  organisation: PropTypes.string.isRequired,
};
